
      import Servers from './servers.vue'
      import type { App, Plugin } from 'vue'

      export const ServersPlugin: Plugin = {
        install(app: App) {
          app.component('Servers', Servers)
        },
      }
      export { Servers }
      